import { useEffect } from 'react';
import { useAuth } from 'contexts/User';
import { useContext } from 'react';
import { ModalContext } from 'contexts/Modal';

export const usePrivacyTermsCheck = () => {
  const { userData, loading } = useAuth();
  const { modalState, modalDispatch } = useContext(ModalContext);

  useEffect(() => {
    // Only check if user data is loaded and user is authenticated
    if (!loading && userData && userData.exists()) {
      const userDataObj = userData.data() as any;

      // Check if privacy policy or terms of service are null or empty
      const needsAcceptance =
        !userDataObj?.acceptedPrivacyPolicy ||
        !userDataObj?.acceptedTermsOfService;

      if (needsAcceptance && !modalState.privacyTermsAcceptance) {
        // Show the modal
        modalDispatch({ type: 'privacyTermsAcceptance', payload: true });
      } else if (!needsAcceptance && modalState.privacyTermsAcceptance) {
        // Hide the modal if acceptance is no longer needed
        modalDispatch({ type: 'privacyTermsAcceptance', payload: false });
      }
    }
  }, [userData, loading, modalState.privacyTermsAcceptance, modalDispatch]);

  const handleAcceptance = () => {
    // Close the modal after acceptance
    modalDispatch({ type: 'privacyTermsAcceptance', payload: false });
  };

  return {
    showModal: modalState.privacyTermsAcceptance,
    handleAcceptance,
  };
};
